import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { urlConstants } from '../../common/urlConstants';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { WorkItemResponseDto } from '../../models/workItemResponseDto';
import { DocInfo } from '../../models/documentInfoDto';
import { WorkflowHistoryResponse } from '../../models/workflow-history.model';
import { MoveWorkItemDto, NextWorkItem, SaveDocHistoryDto } from '../../models/moveWorkItemDto';
import { VendorEmailDto } from '../../models/vendorEmailDto';
import { IndexFields } from '../../models/index-fields';

@Injectable({
  providedIn: 'root'
})
export class DocumentViewerService {

  constructor(private readonly http: HttpClient) { }

  getDocumentLink(userGPID: string, systemId: string, documentId: string, type: string): Observable<string> {
    const routeUrl = `${environment.apiUrl}${urlConstants.link}${userGPID}/${systemId}/${documentId}/${type}`;
    return this.http.get(routeUrl, { responseType: 'text' });
  }

  downloadWorkItem(userGPID: string, systemId: string, documentId: any): Observable<any> {
    const downloadUrl = `${environment.apiUrl}${urlConstants.downloadWorkItem}${userGPID}/${systemId}/${documentId}`;
    return this.http.get(downloadUrl, { responseType: 'text' });
  }

  getSelectFields(userGPID: string, systemId: string, documentID: string): Observable<any> {
    const selectFieldsUrl = `${environment.apiUrl}${urlConstants.workItemIndexingFields}${userGPID}/${systemId}/${documentID}`;
    return this.http.get<any>(selectFieldsUrl);
  }

  getDocumentsLinkInfo(userGPID: string, systemId: string, documentID: string): Observable<DocInfo[]> {
    const documentsInfoUrl = `${environment.apiUrl}${urlConstants.documentsInfoURL}${userGPID}/${systemId}/${documentID}`;
    return this.http.get<DocInfo[]>(documentsInfoUrl);
  }

  getBatchDocuments(userGPID: string, systemId: string, batchId: string): Observable<any> {
    const getBatchDocumentsUrl = `${environment.apiUrl}${urlConstants.batchDocumentsURL}${userGPID}/${systemId}/${batchId}`;
    return this.http.get<any>(getBatchDocumentsUrl);
  }

  getBatchHierarchyInfo(userGPID: string, systemId: string, batchId: string): Observable<any> {
    const getBatchHierarchyInfoUrl = `${environment.apiUrl}${urlConstants.batchHierarchyInfo}${userGPID}/${systemId}/${batchId}`;
    return this.http.get<any>(getBatchHierarchyInfoUrl);
  }

  getEmailWIInfo(userGPID: string, systemId: string, storageRepoId: string): Observable<any> {
    const getEmailWiInfoUrl = `${environment.apiUrl}${urlConstants.emailWI}${userGPID}/${systemId}/${storageRepoId}`;
    return this.http.get<any>(getEmailWiInfoUrl);
  }

  getMasterBatchInfo(userGPID: string, systemId: string, inputValue: string): Observable<any> {
    const getMasterBatchInfoUrl = `${environment.apiUrl}${urlConstants.masterBatchInfo}${userGPID}/${systemId}/${inputValue}`;
    return this.http.get<any>(getMasterBatchInfoUrl);
  }
  
  getWorkItemDetails(userGPID: string, systemId: string, inputValue: string): Observable<WorkItemResponseDto> {
    const getWorkItemDetailsUrl = `${environment.apiUrl}${urlConstants.getWorkItemURL}${userGPID}/${systemId}/${inputValue}/true`;
    return this.http.get<any>(getWorkItemDetailsUrl);
  }

  workItemLockUnLock(userGPID: string, systemId: string, gpid: string, instanceId: string, isLock: number): Observable<any> {
    const workItemLockUnlockUrl = `${environment.apiUrl}${urlConstants.workItemLockUnLockURL}${userGPID}/${systemId}/${gpid}/${instanceId}/${isLock}`;
    return this.http.get<any>(workItemLockUnlockUrl);
  }

  getVendorEmailDetails(userGPID: string, systemId: string, supplierCountry: string, ReasonCode: string, CompanyCodeID: string, VendorId: string): Observable<VendorEmailDto[]> {
    const vendorEmailDetailsUrl = `${environment.apiUrl}${urlConstants.onVendorEmail}${userGPID}/${systemId}/${supplierCountry}/${ReasonCode}/${CompanyCodeID}/0/${VendorId}`;
    return this.http.get<VendorEmailDto[]>(vendorEmailDetailsUrl);
  }

  getWorkflowHistory(userGPID: string, systemId: string, Id: string, isBatchId: boolean = false): Observable<WorkflowHistoryResponse[]> {
    const workflowHistoryurl = isBatchId
      ? `${environment.apiUrl}${urlConstants.viewBatchWorkFlowHistoryURL}${userGPID}/${systemId}/${Id}`
      : `${environment.apiUrl}${urlConstants.viewDocumentWorkFlowHistoryURL}${userGPID}/${systemId}/${Id}`;

    return this.http.get<WorkflowHistoryResponse[]>(workflowHistoryurl);
  }

  routeWorkItem(moveWorkItemDto: MoveWorkItemDto): Observable<any> {
    const routeUrl = `${environment.apiUrl}${urlConstants.moveWorkItemURL}`;
    return this.http.post<any>(routeUrl, moveWorkItemDto);
  }

  getNextWorkItem(nextWorkItemDto: NextWorkItem): Observable<any> {
    const routeUrl = `${environment.apiUrl}${urlConstants.GetNextWorkItem}`;
    return this.http.post<any>(routeUrl, nextWorkItemDto);
  }

  saveDocHistory(saveDocHistoryDto: SaveDocHistoryDto): Observable<any> {
    const saveDocHistoryUrl = `${environment.apiUrl}${urlConstants.SaveDocHistory}`;
    return this.http.post<any>(saveDocHistoryUrl, saveDocHistoryDto);
  }
  
  saveWorkItem(userGPID: string, systemId: string, indexingFields: IndexFields[], checkMandatory: boolean, docId: string): Observable<any> {
    const saveIndexFieldsUrl = `${environment.apiUrl}${urlConstants.saveIndexingFields}${userGPID}/${systemId}/${docId}/${checkMandatory}`;
    return this.http.post<any>(saveIndexFieldsUrl, indexingFields);
  }
}
